import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core';

class FHESubContainer extends PureComponent {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        classSubContainer: PropTypes.string,
        children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired
    };
    static defaultProps = {
        classSubContainer: ''
    };

    render() {
        const { children, classes, classSubContainer } = this.props;
        return <div className={`${classes.container} ${classSubContainer}`}>{children}</div>;
    }
}

const styles = theme => ({
    container: {
        maxHeight: 'calc(100vh - 385px)',
        overflow: 'auto'
        // [theme.breakpoints.down('sm')]: {
        //     padding: 30
        // },
        // [theme.breakpoints.down('xs')]: {
        //     padding: 10
        // }
    }
});

export default withStyles(styles, { withTheme: true })(FHESubContainer);



// WEBPACK FOOTER //
// ./data/components/FHESubContainer.js